'use strict';

const SoaCollection = require('bunsen/collections/SoaCollection');
const endpoints = require('dibs-endpoints');

const SocialNetwork = require('../../models/identity/SocialNetwork');

const SocialNetworks = SoaCollection.extend({
    url() {
        return endpoints.socialNetworks();
    },

    model: SocialNetwork
});

module.exports = SocialNetworks;



// WEBPACK FOOTER //
// ./~/bunsen/collections/identity/SocialNetworks.es.js